// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonTheme__button--QTLNc","icon":"buttonTheme__icon--KEeyJ","ripple":"buttonTheme__ripple--2Tk-M","accent":"buttonTheme__accent--2s8HP"};